<template>

    <div class="login-page">
        <Header></Header>
        <section class="login-section">
            <div class="container">
                <div class="row">
                    <div class="col-md-5" style="margin: 0 auto;">
                        <h2>Log In</h2>
                        <form class="form" v-on:submit.prevent="loginFormSubmit">
                            <div class="input-field form-input">
                                <label for="your-email">Your Email</label>
                                <input type="text" placeholder="johndoe@email.com" id="your-email" v-model="LoginEmail"
                                       v-on:blur="yourEmail(LoginEmail)">
                                <p class="error-input" v-if="loginFlag">Email address is required</p>
                            </div>
                            <div class="input-field form-input">
                                <label for="your-password">Password</label>
                                <input type="password" placeholder="*******" v-model="PasswordEmail" id="your-password"
                                       v-on:blur="yourPassword(PasswordEmail)">
                                <p class="error-input" v-if="passwordFlag">Password is required</p>
                            </div>
                            <div class="input-submit">
                                <button type="submit" v-if="!FormSubmited">SIGN IN</button>
                                <span v-if="FormSubmited">SIGN IN...</span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
        <Footer></Footer>
    </div>
</template>

<style>
    body {
        background-color: #ffffff;
    }
</style>

<script>
    import Header from './Header'
    import Footer from './Footer'
    import axios from 'axios'
    import router from '../../router'

    import Vue from 'vue'
    import VueToast from 'vue-toast-notification'
    import 'vue-toast-notification/dist/index.css'
    Vue.use(VueToast)

    export default {
        name: 'AdminLogin',
        components: {
            'Header': Header,
            'Footer': Footer
        },
        data() {
            return {
                loginFlag: false,
                passwordFlag: false,
                LoginEmail: '',
                PasswordEmail: '',
                FormSubmited: false,
                msg: 'Welcome to Your Vue.js App'
            }
        },
        mounted () {
            if(router.history.current.query.email && router.history.current.query.token){
                axios
                    .get('/checkUser', {
                        params: {
                            email: router.history.current.query.email,
                            token: router.history.current.query.token
                        }
                    })
                    .then(response => {
                        console.log(response)
                        Vue.$toast.open(
                            {
                                message: 'Congs Signup Success',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                    })
                    .catch(error => console.log(error))
            }
        },
        methods: {
            yourEmail: function (msg) {
                if (!msg) {
                    this.loginFlag = true
                } else {
                    this.loginFlag = false
                }
            },
            yourPassword: function (msg) {
                if (!msg) {
                    this.passwordFlag = true
                } else {
                    this.passwordFlag = false
                }
            },
            loginFormSubmit: function (event) {
                this.FormSubmited = true
                if(this.LoginEmail){
                    this.LoginEmail = this.LoginEmail.trim().toLowerCase()
                }
                axios.post('/adminLogin',
                    {
                        email: this.LoginEmail,
                        password: this.PasswordEmail
                    }).then(res => {
                    if(res.data.error == 'User does not exist'){
                        Vue.$toast.open(
                            {
                                message: 'User does not exist!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.FormSubmited = false
                    } else if(res.data.error == 'Password or Email is wrong'){
                        Vue.$toast.open(
                            {
                                message: 'Password or Email is wrong!',
                                type: 'error',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        this.FormSubmited = false
                    } else {
                        Vue.$toast.open(
                            {
                                message: 'Login successfully!',
                                type: 'success',
                                position: 'top-right'
                                // all other options
                            }
                        )
                        localStorage.setItem('cbs_admin_usertoken', JSON.stringify(res.data))
                        this.LoginEmail = ''
                        this.PasswordEmail = ''
                        router.push({ path: '/admin/artists/' })
                    }
                }).catch(err => {
                    this.FormSubmited = false
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/admin/Login.vue